import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { API } from "@/assets";
import { useSiteAuth } from "@/components/GoogleAuth";
import { Loader2 } from "lucide-react";

export const AuthCallback = () => {
  const processed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useSiteAuth();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/account", { replace: true, state: { authError: true } });
      return;
    }
    fetch(`${API}/auth/google/session`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error("exchange failed"))))
      .then((u) => {
        setUser(u);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/account", { replace: true, state: { user: u } });
      })
      .catch(() => navigate("/account", { replace: true, state: { authError: true } }));
  }, [navigate, setUser]);

  return (
    <main className="min-h-screen bg-obsidian flex items-center justify-center" data-testid="auth-callback">
      <Loader2 className="animate-spin text-venom" size={30} aria-label="Signing you in" />
    </main>
  );
};
